export const ROLES = {
  agent: 'assistant',
  user: 'user',
};
